import { DatePicker } from "antd";
import { DatePickerProps as DefaultDatePickerProps } from "antd/lib/date-picker";
import { FC } from "react";
import dayjs from "dayjs";

export type DateInputValue = dayjs.Dayjs;

export type DateInputProps = Omit<DefaultDatePickerProps, "onChange"> & {
  label?: string;
  onChange: (value: DateInputValue) => void;
};

const DateInput: FC<DateInputProps> = ({
  label = "Reference Date",
  format = "MM-DD-YYYY",
  onChange,
  ...rest
}) => {
  return (
    <div className="input-component">
      {!!label && <div className="input-component__label">{label}</div>}
      <div className="input-component__input">
        <DatePicker
          {...rest}
          format={format}
          onChange={(value) => {
            onChange(value as DateInputValue);
          }}
        />
      </div>
    </div>
  );
};

export default DateInput;
